var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:_vm.firstElClasses},[_vm._v("\n        "+_vm._s(_vm.pagination.page * _vm.pagination.pageSize + 1 - _vm.pagination.pageSize)+"\n        -\n    ")]),_vm._v("\n    "+_vm._s(Math.min(
            _vm.pagination.page * _vm.pagination.pageSize,
            _vm.pagination.totalProducts
        ))+"\n\n    из "+_vm._s(_vm.pagination.totalProducts)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }